import React from "react";
import { IoMdClose } from "react-icons/io";
import styles from "./deleteModal.module.css";

const DeleteModal = ({ onClose, onDelete, theme, time, isDeleting,isRandom }) => {
  return (
    <div className={`${styles.modalOverlay} fontPoppins `}>
      <div className={`${styles.modal} ${theme === "dark" ? styles.dark : styles.light}`}>
        <div className={styles.modalHeader}>
          <h2>Delete Screenshot</h2>
          <button onClick={onClose} className={styles.closeButton}>
            <IoMdClose className="w-6 h-6" />
          </button>
        </div>
        <div className={styles.modalContent}>
          <p>Are you sure you want to delete this screenshot?</p>
          <p>Your time {isRandom ? 'of slected screenshot': time} will not be counted.</p>
        </div>
        <div className={styles.modalFooter}>
          <button 
            onClick={onClose}
            className={`${styles.button} ${styles.cancelButton} rounded-full `}
          >
            Cancel
          </button>
          <button 
            onClick={onDelete}
            className={`${styles.button} ${styles.deleteButton} heroButton outline-none `} disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...':'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal; 